/**
 * Cards side by side, each snapping to the middle: swiped sideways on a phone, a column in the
 * sidebar. The build menu's blueprints and a machine's levels are laid out with it.
 */
import { useLayoutEffect, useRef, type JSX, type ReactNode } from 'react';

import './cards.css';

export function CardStrip({
  children,
  label,
  focus,
}: {
  /** One `<li>` per card. */
  children: ReactNode;
  label?: string;
  /** The card in the middle at first, by its place in the strip. */
  focus?: number | undefined;
}): JSX.Element {
  const strip = useRef<HTMLUListElement>(null);
  useLayoutEffect(() => {
    const el = strip.current;
    const card = focus === undefined ? undefined : el?.children[focus];
    if (!el || !(card instanceof HTMLElement)) return;
    el.scrollLeft = card.offsetLeft - (el.clientWidth - card.offsetWidth) / 2;
  }, [focus]);
  return (
    <ul className="card-strip" ref={strip} aria-label={label}>
      {children}
    </ul>
  );
}
